import styled from 'styled-components';
import { colorPalette } from '../../../config';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const MapWrapper = styled.div`
	width: 100%;
	margin-bottom: 4rem;
	text-align: center;
`;

export const CardSectionWrapper = styled.div``;

export const TitleWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;

	> div {
		margin: 0 10% 2rem 0;
	}
`;
export const ShuttleButtonWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	margin: 0 0 32px 0;

	a {
		display: inline-flex;
		align-items: center;
		justify-content: center;

		min-width: 240px;
		height: 56px;
		padding: 0 32px;

		border-radius: 8px;
		background: ${colorPalette.primary};

		color: ${colorPalette.white};
		font-size: 18px;
		font-weight: 700;
		text-decoration: none;

		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			opacity: 0.85;
		}
	}

	@media (max-width: 768px) {
		margin: 0 0 24px 0;

		a {
			width: 100%;
			min-width: 0;
			height: 52px;
			font-size: 16px;
		}
	}
`;
